import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-factures',
  templateUrl: './factures.component.html',
  styleUrls: ['./factures.component.css']
})
export class FacturesComponent implements OnInit {
  factures:any;
  constructor(public userService:UserService) { }

  ngOnInit(): void {
    this.userService.getFactures().subscribe(res=>{
      this.factures = res["data"];
    })
  }
  public openPDF(): void {
    let DATA: any = document.getElementById('tableBalance');
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('angular-demo.pdf');
    });
  }

}
